import "./bootstrap";

import "alpinejs";
import "jquery-mask-plugin";
import "select2";
import "geocomplete";

import "./f-number";
import "./jquery.payment";

// if (!!window.performance && window.performance.navigation.type === 2) {
//     window.location.reload();
// }

window.onpageshow = function (event) {
    if (event.persisted) {
        window.location.reload();
    }
};

window.breakComponent = function (address) {
    const location = {
        address1: "",
        postalCode: "",
        city: "",
        state: "",
    };
    _.map(address, (component) => {
        if (component["types"][0] === "street_number") {
            location.address1 = component["long_name"];
        }
        if (component["types"][0] === "route") {
            location.address1 = `${location.address1} ${component["long_name"]}`;
        }
        if (component["types"][0] === "locality") {
            location.city = component["long_name"];
        }
        if (component["types"][0] === "administrative_area_level_1") {
            location.state = component["short_name"];
        }
        if (component["types"][0] === "postal_code") {
            location.postalCode = component["long_name"];
        }
    });

    return location;
};

window.loading = function (wait = 240000) {
    window.start();
    setTimeout(function () {
        window.end()
    }, wait);
}
window.start = function () {
    $('body').find('#l-spinner').show().end().addClass('overflow-hidden');
}
window.end = function () {
    $('body').find('#l-spinner').hide().end().removeClass('overflow-hidden');
}

window.geoCompleteLocation = function (cb) {
    $("input[name='address.address1']")
        .geocomplete({Placeholder: "", country: "US"})
        .bind("geocode:result", function (event, result) {
            const {address_components} = result;
            cb("address", breakComponent(address_components));
        });

    $("input[name='lein.address1']")
        .geocomplete({Placeholder: "", country: "US"})
        .bind("geocode:result", function (event, result) {
            const {address_components} = result;
            cb("lein", breakComponent(address_components));
        });

    $("input[name='garaging.address1']")
        .geocomplete({country: "US"})
        .bind("geocode:result", function (event, result) {
            const {address_components} = result;
            cb("garaging", breakComponent(address_components));
        });

    $("input[name='billing.address1']")
        .geocomplete({country: "US"})
        .bind("geocode:result", function (event, result) {
            const {address_components} = result;
            cb("billing", breakComponent(address_components));
        });
};

$(document).ready(function () {
    $(".jj-spinner").on("click", function () {
        $("body").find("#l-spinner").show().end().addClass("overflow-hidden");
    });
    $('.cc-number').payment('formatCardNumber');
    $('.cc-exp').payment('formatCardExpiry');
    $('.cc-cvc').payment('formatCardCVC');

    // Disabled copy and paste in the input box
    $('[data-disabled-p]').on('paste', function (e) {
        e.preventDefault();
    })
});
